export enum StatementOCRTabs {
  UPLOAD = 'UPLOAD',
}

export enum LedgerRole {
  BANK_ACCOUNT = 'BANK_ACCOUNT',
  CREDIT_CARD = 'CREDIT_CARD',
  EQUITY_ACCOUNT = 'EQUITY_ACCOUNT',
  STATEMENT_PROCESSING_ACCOUNT = 'STATEMENT_PROCESSING_ACCOUNT',
}

export type LedgerAccount = {
  id: string;
  name: string;
  active: boolean;
  role: LedgerRole;
};
